import { Translations } from './types';

export const en: Translations = {
  // App & Branding
  app_title: 'Slimelings: Bit-It!',
  app_subtitle: 'The Fast-Paced Bluffing Card Game',
  app_slogan: 'Double the trouble... half the remorse.',
  app_description: 'Fast-paced card battles for 1 to 4 players. Bluff, escalate with Bit-It!, and reach 16 points to win.',

  // Locales
  lang_pt: 'Português (BR)',
  lang_en: 'English (US)',
  lang_pl: 'Polski (PL)',

  // Game Modes
  mode_duel: '1v1 Duel',
  mode_duel_desc: 'Head-to-head showdown against a single opponent.',
  mode_teams: '2v2 Teams',
  mode_teams_desc: 'You and your partner versus the rival team.',
  mode_ffa: '4-Player Free-For-All (FFA)',
  mode_ffa_desc: 'Tactical chaos: 4 individual players contesting each trick.',

  // Bot Personalities & Levels
  bot_level_1: 'Level 1 (Easy)',
  bot_level_2: 'Level 2 (Medium)',
  bot_level_3: 'Level 3 (Hard)',
  bot_aggressive: 'Level 3 (Hard)',
  bot_cautious: 'Level 1 (Easy)',
  bot_minimax: 'Level 2 (Medium)',
  bot_aggressive_desc: 'Level 3',
  bot_cautious_desc: 'Level 1',
  bot_minimax_desc: 'Level 2',

  // Navigation & Lobby
  tab_solo: 'Solo Play (vs Bots)',
  tab_multiplayer: 'Online Multiplayer',
  tab_rules: 'Official Rules',
  btn_create_room: 'Create Room',
  btn_join_room: 'Join Room',
  btn_start_game: 'Start Game',
  btn_add_bot: 'Add Bot',
  btn_leave: 'Leave Room',
  btn_copy_link: 'Copy Link',
  link_copied: 'Room link copied to clipboard!',
  room_code: 'Room Code',
  enter_room_code: 'Enter room code (e.g. SLIME-8)',
  room_status_waiting: 'Waiting for players...',
  room_status_playing: 'Match in progress',
  room_private: 'Private Room',
  room_public: 'Public Room',
  toggle_public: 'Make Room Public',
  toggle_private: 'Make Room Private',
  public_rooms: 'Open Public Rooms',
  no_public_rooms: 'No open public rooms right now. Create one!',
  players_joined: 'Players in Room',
  player_you: 'You',
  player_host: 'Room Host',
  player_bot: 'AI Bot',
  team_a: 'Blue Team (A)',
  team_b: 'Red Team (B)',

  // In-Game Actions
  action_bit_it: 'BIT-IT! (Double)',
  action_double_bit_it: 'DOUBLE BIT-IT! (Re-Double)',
  action_face: 'Face Challenge',
  action_fold: 'Fold (Protect)',
  action_play_card: 'Play Card',
  action_drag_or_tap: 'Drag card to center or tap to play',
  your_turn: 'Your turn to play!',
  waiting_for_player: 'Waiting for {name}...',
  waiting_for_challenge_response: 'Waiting for challenge response...',
  btn_dismiss_hint: 'Dismiss hint',

  // Announcements & Game Events
  event_bit_it_called: '{name} called BIT-IT! Stakes raised to {stakes} points.',
  event_double_bit_it_called: '{name} answered with DOUBLE BIT-IT! Max stakes capped at {stakes} points.',
  event_player_faced: '{name} faced the challenge.',
  event_player_folded: '{name} folded and protected their score.',
  event_bluff_win: 'Everyone folded. {name} won the round by bluff!',
  event_corven_slay: 'Ezarion\'s Abate! {name} played Corven and defeated Ezarion. Instant Round Victory!',
  event_trick_won: 'Trick {trick}: {name} won with {card} (Power {power}).',
  event_trick_tied: 'Trick {trick} was tied.',
  event_triple_tie: 'Triple tie on all 3 tricks. Base stakes for next round are doubled!',
  event_round_won: 'Round over. Winner: {name} (+{points} pts).',
  event_match_won: 'Grand Victory! {name} reached the goal of {points} points!',
  round_num: 'Round {num}',
  trick_num: 'Trick {num}/3',
  stakes_current: 'Worth {stakes} pts',
  stakes_normal: 'Normal (2 pts)',
  stakes_bit_it: 'BIT-IT! (4 pts)',
  stakes_double_bit_it: 'DOUBLE BIT-IT! (8 pts)',
  dealer_badge: 'Dealer',

  // Scoreboard
  scoreboard_title: 'Scoreboard (Match ends at 16 points)',
  binary_bits: 'Point Gems: [1] [2] [4] [8]',
  pts_counter: '{score} / 16 pts',
  target_goal: 'Match ends at 16 points',

  // Card Names
  card_ezarion: 'Ezarion (10)',
  card_phantom_general: 'Phantom General (9)',
  card_arrowin: 'Arrowin (8)',
  card_smerlin: 'Smerlin (7)',
  card_kx9: 'KX-9 (6)',
  card_koram: 'Koram (6)',
  card_wizzik: 'Wizzik (5)',
  card_brutus: 'Brutus (4)',
  card_snappy: 'Snappy (3)',
  card_zingo: 'Zingo (2)',
  card_floppy: 'Floppy (1)',
  card_corven: 'Corven (0)',
  card_corven_desc: 'Power 0. Ability: Ezarion\'s Abate. Sleys Ezarion (10) and wins the round instantly if played after him in the same trick!',

  // Rules Dialog
  rules_title: 'Official Rules of Slimelings: Bit-It!',
  rules_tab_basics: 'Overview',
  rules_tab_cards: 'Deck (30 Cards)',
  rules_tab_bit_it: 'The Bit-It! Challenge',
  rules_tab_tiebreaks: 'Tiebreaks & Corven',
  rules_deck_overview: 'The deck contains 30 cards: 6 Gold (powers 6 to 10), 20 Commons (4 each of 1 to 5), and 4 Corvens (0). Each player receives 3 cards per round.',
  rules_corven_slay_desc: 'Corven (0) has zero regular power, but possesses the supreme ability Ezarion\'s Abate: if played AFTER Ezarion (10) is already on the table in that trick, Corven slays Ezarion and immediately wins the entire round for their team!',
  rules_tiebreak_desc: 'Winning 2 tricks wins the round. Ties on trick 2 or 3 are awarded to the winner of trick 1 ("First trick rules"). If all 3 tricks tie, the next round carries doubled base points.',
  rules_bit_it_ladder: 'Scoring ladder: Round starts worth 1 if fold / 2 if won. If someone calls Bit-It! and nobody accepts, caller wins 1 point. If accepted, stakes raise to 2 if fold / 4 if won. If someone calls Double Bit-It! and opponent folds, caller wins 2 points; if accepted, stakes raise to 4 if fold / 8 if won. Match ends at 16 points.',
  rules_binary_desc: '4 gems of [1, 2, 4, 8] track your score. The match ends at 16 points!',
  btn_close: 'Close',

  // Emotes & Chat
  emote_hello: 'Hello everyone!',
  emote_good_luck: 'Good luck!',
  emote_bit_it: 'BIT-IT! Dare to face?',
  emote_no_way: 'No way!',
  emote_well_played: 'Well played!',
  emote_oops: 'Oops, my bad!',
  emote_haha: 'Haha, got you!',
  emote_nice_try: 'Nice try!',

  // Settings & Status
  sound_on: 'Sound: On',
  sound_off: 'Sound: Muted',
  mode_offline: 'Offline Local Mode',
  error_room_not_found: 'Room not found. Please check the code and try again.',
  error_room_full: 'This room is already full (player limit reached).',
  error_invalid_code: 'Invalid room code. Please enter 4 to 12 alphanumeric characters.',
  btn_play_again: 'Play Again',
  btn_back_to_lobby: 'Back to Lobby',
  status_connected: 'Connected',
  slime_chat: 'Chat',
  event_player_emote: '{name}: "{emote}"',
  player_opponent: 'Opponent',
  player_champion: 'Champion',
  card_point: '{val} pt',
  btn_main_menu: 'Main Menu',
  btn_next_round: 'Next Round',
  round_end_title: 'Round Over',
  round_winner_you: 'You won the round!',
  round_winner_other: '{name} won the round!',
  round_tied: 'Round Tied!',
  round_points_awarded: '+{points} points',
  match_victory: 'Victory!',
  match_defeat: 'Defeat',
  match_stats_rounds: 'Rounds played',
  match_stats_final_score: 'Final score',
};
